export const circleColorExpression = (paint = {}) => {
  if (paint.circleColorField && paint.circleColorStops) {
    const stops = paint.circleColorStops.flat()
    return ['interpolate', ['linear'], ['coalesce', ['to-number', ['get', paint.circleColorField]], 0], ...stops]
  }

  if (!paint.statusColorField || !paint.statusColors) return paint.circleColor || '#2563eb'

  const matchPairs = Object.entries(paint.statusColors).flatMap(([status, color]) => [status, color])
  return ['match', ['get', paint.statusColorField], ...matchPairs, paint.circleColor || '#2563eb']
}

export const circleRadiusExpression = (paint = {}) => {
  if (!paint.radiusField || !paint.radiusStops) return paint.circleRadius || 5

  const stops = paint.radiusStops.flat()
  return ['interpolate', ['linear'], ['coalesce', ['to-number', ['get', paint.radiusField]], 0], ...stops]
}
